/** Pestañas del detalle de tenant (`?tab=`). Única fuente: el router las valida y la pantalla las pinta; un test recorre todas. */
export const TENANT_DETAIL_TABS = [
  'summary',
  'members',
  'plan',
  'channels',
  'budget',
  'services',
  'labels',
  'privacy',
] as const;
export type TenantDetailTab = (typeof TENANT_DETAIL_TABS)[number];
